import actions from './actions'
import mutations from './mutations'
import { parseJSON } from '@/utils/helpers'

const app = {
	state: {
		device: 'desktop',
		countryCode: 'ukr',
		language: setDefaultLocale(),
		token: localStorage.token,
		confirmed: localStorage.confirmed == 'true',
		confirmedCodeLength: Number(localStorage.confirmedCodeLength) || 4,
		user: null,
		brandCode: window.brandCode,
		cities: [],
		defaultCity: parseJSON(localStorage.city),
		showClose: Boolean(Number(window.showClose))
	},
	mutations,
	actions
}

function setDefaultLocale() {
	const locales = ['en', 'ru', 'uk']

	if (window.lang && locales.includes(window.lang)) {
		return window.lang
	} else if (locales.includes(localStorage.language)) {
		return localStorage.language
	} else {
		return locales.find(it => it == 'ru')
	}
}

export default app
